module.exports = __webpack_public_path__ + "img/victoria.5bf28ad1.jpg";